// extracted by mini-css-extract-plugin
module.exports = {"agreement":"TermsScreen_agreement__3vy22","cta":"TermsScreen_cta__1SaoO"};